export default __webpack_public_path__ + "static/media/image.tunclab-solutions.5984f91f.png";